export * from './useDeclarationQuestions';

export * from './types';

export {
	getMedicalDeclarationQuestions,
	type MedicalDeclarationQuestionsResponse,
	type QuestionTypeSchema,
	type AnswerTypeSchema,
	QuestionTypes,
} from '@shory-health-individual/customer-api';
